export const PROD_HOSTNAME = "screenforepiincp.com" as const;

export const BUGHERD_SRC = "https://www.bugherd.com/sidebarv2.js?apikey=2hd47wgy8yt6ukwgq0p0wg";
